/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Themedescription2Inputs */

const zh_systemsettings_themedescription2 = /** @type {(inputs: Systemsettings_Themedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择您偏好的主题模式。`)
};

const en_systemsettings_themedescription2 = /** @type {(inputs: Systemsettings_Themedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose your preferred theme mode.`)
};

const es_systemsettings_themedescription2 = /** @type {(inputs: Systemsettings_Themedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige tu modo de tema preferido.`)
};

/**
* | output |
* | --- |
* | "Choose your preferred theme mode." |
*
* @param {Systemsettings_Themedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_themedescription2 = /** @type {((inputs?: Systemsettings_Themedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Themedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_themedescription2(inputs)
	if (locale === "en") return en_systemsettings_themedescription2(inputs)
	return es_systemsettings_themedescription2(inputs)
});
export { systemsettings_themedescription2 as "systemSettings_themeDescription" }